import {
  type PropsWithChildren,
  type SetStateAction,
  useMemo,
  useState,
} from "react";

import { type TFlightFormValues } from "@/types/types";

import { FlightSearchDataContext } from "./FlightSearchDataContext";

export const FlightSearchDataProvider = ({ children }: PropsWithChildren) => {
  const [searchData, setSearchData] = useState<TFlightFormValues | null>(null);

  const contextValue = useMemo(
    () => ({
      searchData,
      updateSearchData: (data: SetStateAction<TFlightFormValues | null>) => {
        window.dispatchEvent(new CustomEvent("searchdataupdated"));
        setSearchData(data);
      },
    }),
    [searchData, setSearchData],
  );

  return (
    <FlightSearchDataContext.Provider value={contextValue}>
      {children}
    </FlightSearchDataContext.Provider>
  );
};
